import { Grid } from '@mui/material';

export type GridProps = {
  children: React.ReactNode[]
};

export const GridUI: React.FC<GridProps> = ({ children }) => {
  return (
    <Grid
      container
      spacing={0.125} // 1px gap
    >
      {children.map((child, i) => (
        <Grid
          item
          xs={6}
          sm={6}
          key={i}
          sx={{
            aspectRatio: '16/9',
            overflow: 'hidden',
            position: 'relative',
          }}
        >
          {child}
        </Grid>
      ))}
    </Grid>
  );
};
